// İSG uzmanı portalı — Taşeron/Yüklenici (Contractors) TanStack Query anahtarları
// (api-contract §13, tenant-scoped). Liste anahtarı parametreleri içerir (durum/arama/
// sayfa değişince yeniden çeker); invalidasyon önek (prefix) ile yapılır: `['contractors',
// 'list']` tüm liste sorgularını, `['contractors','detail',uuid]` bir taşeronun tüm
// alt-sekmelerini (belge/personel/saha) kapsar.
//
// Ziyaretçi (§11) / Ayarlar (§10) / Admin (§9) anahtarlarından AYRIDIR — Taşeron tek
// firmaya kapsanmış tenant iş modülüdür.

import type { ContractorListParams } from '@isgportal/shared';

export const contractorsKeys = {
  /** Tüm taşeron sorgularının kök öneki — invalidasyon için. */
  all: () => ['contractors'] as const,
  /** Tüm liste sorgularının öneki (arama/durum/sayfa varyantlarını kapsar). */
  list: () => ['contractors', 'list'] as const,
  /** Sayfalı + filtreli liste — parametreli. */
  listParams: (params: ContractorListParams) => ['contractors', 'list', params] as const,
  /** Erişim sondası (gate) — hafif liste probu (page=1, pageSize=1). */
  access: () => ['contractors', 'access'] as const,
  /** Tek taşeron detayı — tüm alt-sekmeleri kapsayan önek. */
  detail: (uuid: string) => ['contractors', 'detail', uuid] as const,
  /** Taşeronun uygunluk belgeleri. */
  documents: (uuid: string) => ['contractors', 'detail', uuid, 'documents'] as const,
  /** Taşeronun personeli. */
  personnel: (uuid: string) => ['contractors', 'detail', uuid, 'personnel'] as const,
  /** Taşeronun saha erişimleri. */
  sites: (uuid: string) => ['contractors', 'detail', uuid, 'sites'] as const,
  /** Taşeronun araç kaydı (belgeler gömülü; §23). */
  vehicles: (uuid: string) => ['contractors', 'detail', uuid, 'vehicles'] as const,
  /** Bir personelin belgeleri (§15 yol A — KVKK; kişi bazlı). */
  personnelDocuments: (uuid: string, userUuid: string) =>
    ['contractors', 'detail', uuid, 'personnel', userUuid, 'documents'] as const,
} as const;
